// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3N9m_","buttons":"Footer_buttons__1X07s"};